/** Read once at start-up: a missing or malformed address stops the app with a clear message. */
function readApiUrl(): string {
  const value: unknown = import.meta.env.VITE_API_URL;
  if (typeof value !== 'string' || !/^https?:\/\/[^/]+/.test(value)) {
    throw new Error(
      'VITE_API_URL must be the backend address, e.g. http://localhost:3000 (see .env.example)',
    );
  }
  return value.replace(/\/+$/, '');
}

export const API_URL = readApiUrl();

/** The Shopify store, for links to its products (dry-run comparisons, duplicates). */
export const STORE_URL = readStoreUrl();

function readStoreUrl(): string {
  const value: unknown = import.meta.env.VITE_STORE_URL;
  return typeof value === 'string' && /^https?:\/\/[^/]+/.test(value)
    ? value.replace(/\/+$/, '')
    : 'https://sawakart.com';
}
